module.exports = __webpack_public_path__ + "img/2.c81515c5.png";